import { Validator } from 'breeze-client';
import { ColorValidator } from './validators/color.validator';
import { EmotionsValidator } from './validators/emotions.validator';
import { FacebookValidator } from './validators/facebook.validator';
import { GoogleValidator } from './validators/google.validator';
import { LinkedInValidator } from './validators/linkedin.validator';
import { NumberValidator } from './validators/number.validator';
import { PeriodValidator } from './validators/period.validator';
import { SkypeValidator } from './validators/skype.validator';
import { TwitterValidator } from './validators/twitter.validator';
import { XingValidator } from './validators/xing.validator';
import { RangeValidator } from './validators/range.validator';
import { CurrencyValidator } from './validators/currency.validator';
export var VALIDATORS = [
    ColorValidator,
    CurrencyValidator,
    EmotionsValidator,
    FacebookValidator,
    GoogleValidator,
    LinkedInValidator,
    NumberValidator,
    PeriodValidator,
    SkypeValidator,
    TwitterValidator,
    XingValidator,
    RangeValidator
];
var CoreModule = /** @class */ (function () {
    /**
     * Creates an instance of CoreModule. Sets validator message templates.
     * @memberOf CoreModule
     */
    function CoreModule() {
        Validator.messageTemplates['date'] = 'APP.DOMAIN.VALIDATORS.DATE';
        Validator.messageTemplates['required'] = 'APP.DOMAIN.VALIDATORS.REQUIRED';
        Validator.messageTemplates['phone'] = 'APP.DOMAIN.VALIDATORS.PHONE';
        Validator.messageTemplates['stringLength'] = 'APP.DOMAIN.VALIDATORS.STRINGLENGTH';
        Validator.messageTemplates['duration'] = 'APP.DOMAIN.VALIDATORS.DURATION';
        Validator.messageTemplates['url'] = 'APP.DOMAIN.VALIDATORS.URL';
        Validator.messageTemplates['emailAddress'] = 'APP.DOMAIN.VALIDATORS.EMAILADDRESS';
    }
    return CoreModule;
}());
export { CoreModule };
